module.exports = __webpack_public_path__ + "img/144.fe197c98.png";